import { computed, reactive, watch } from '@vue/composition-api';
import store from '@/store';
import { snackbar } from '@/components/GlobalSnackbar';
import { actions } from '@/controller';
import { Menu, UserLevel } from '@/types';
import { filterMenus } from '@/filemenu/utils';
import { csvExportDialog, editOpen } from './state';

const setValidationMenu = {
  text: 'Set Validation Only',
  click: () => { store.dispatch.dataset.setValidationOnly(true); },
  disabled: true,
  icon: 'check_box',
  disallowed: [UserLevel.Annotator, UserLevel.Scorer, UserLevel.Annotator, UserLevel.User, UserLevel.Userhigh],
};

const unsetValidationMenu = {
  text: 'Unset Validation Only',
  click: () => { store.dispatch.dataset.setValidationOnly(false); },
  disabled: true,
  icon: 'check_box_outline_blank',
  disallowed: [UserLevel.Annotator, UserLevel.Scorer, UserLevel.Annotator, UserLevel.User, UserLevel.Userhigh],
};

const removeScoresMenu = {
  text: 'Remove All Scores',
  click: () => { store.dispatch.dataset.clearDatasetScores(); },
  disabled: true,
};

const removeAnnotationsMenu = {
  text: 'Remove All Annotations',
  click: () => { actions.clearDatasetAnnotations(); },
  disabled: true,
};

const saveCurrentDatasetMenu = {
  text: 'Save Current Dataset',
  click: async () => {
    await store.dispatch.dataset.saveCurrentDataset();
    snackbar.dispatch({
      text: 'Dataset Saved Successfully',
      buttonIcon: 'mdi-close',
      options: {
        top: true,
        color: 'success',
      },
    });
  },
  disabled: true,
};

const exportCurrentDatasetMenu = {
  text: 'Export to System Dataset',
  click: async () => {
    await store.dispatch.dataset.exportUserDatasetToSystem();
  },
  disabled: true,
};

const exportCurrentDatasetCSVMenu = {
  text: 'Export to CSV',
  click: async () => {
    editOpen.value = true;
    csvExportDialog.value = true;
  },
  disabled: true,
};

const confirmCurrentDatasetMenu = {
  text: 'Confirm Current Dataset',
  click: () => { store.dispatch.dataset.setDatasetStatus('confirmed'); },
  disabled: true,
};

const unconfirmCurrentItem = {
  text: 'Unconfirm Current Dataset',
  click: () => { store.dispatch.dataset.setDatasetStatus('pending'); },
  disabled: true,
};

const isUserDataset = computed(() => store.state.dataset.userDataset);
const currentStudyType = computed(() => store.state.dataset.studyType);

const allMenus = [
  setValidationMenu,
  unsetValidationMenu,
  removeScoresMenu,
  removeAnnotationsMenu,
  saveCurrentDatasetMenu,
  confirmCurrentDatasetMenu,
  unconfirmCurrentItem,
  exportCurrentDatasetMenu,
  exportCurrentDatasetCSVMenu,
];

export const dataset = reactive({
  text: 'Current Dataset',
  menu_width: 250,
  disabled: true,
  menu: [] as Menu[],
});

const validationOnly = computed(() => store.state.dataset.validationOnly);

// // Enable/disable menu items based on user level
// watchEffect(() => {
//   // Mark as enabled/disabled as necessary
//   setValidationMenu.disabled = store.state.dataset.validationOnly === true;
//   unsetValidationMenu.disabled = store.state.dataset.validationOnly === false;

//   // Filter allowed menus
//   dataset.menu = filterMenus(allMenus);
// });

watch(validationOnly, () => {
  dataset.menu = validationOnly.value ? filterMenus([
    unsetValidationMenu,
    removeScoresMenu,
    removeAnnotationsMenu,
    saveCurrentDatasetMenu,
    confirmCurrentDatasetMenu,
    unconfirmCurrentItem,
  ]) : filterMenus([
    setValidationMenu,
    removeScoresMenu,
    removeAnnotationsMenu,
    saveCurrentDatasetMenu,
    confirmCurrentDatasetMenu,
    unconfirmCurrentItem,
  ]);
});

watch(isUserDataset, () => {
  dataset.menu = validationOnly.value ? filterMenus([
    unsetValidationMenu,
    removeScoresMenu,
    removeAnnotationsMenu,
    saveCurrentDatasetMenu,
    confirmCurrentDatasetMenu,
    unconfirmCurrentItem,
  ]) : filterMenus([
    setValidationMenu,
    removeScoresMenu,
    removeAnnotationsMenu,
    saveCurrentDatasetMenu,
    confirmCurrentDatasetMenu,
    unconfirmCurrentItem,
  ]);
  if (isUserDataset.value) {
    dataset.menu.push(exportCurrentDatasetMenu);
  }
  if (currentStudyType.value !== 'motion') {
    dataset.menu.push(exportCurrentDatasetCSVMenu);
  }
});

watch(currentStudyType, () => {
  dataset.menu = validationOnly.value ? filterMenus([
    unsetValidationMenu,
    removeScoresMenu,
    removeAnnotationsMenu,
    saveCurrentDatasetMenu,
    confirmCurrentDatasetMenu,
    unconfirmCurrentItem,
  ]) : filterMenus([
    setValidationMenu,
    removeScoresMenu,
    removeAnnotationsMenu,
    saveCurrentDatasetMenu,
    confirmCurrentDatasetMenu,
    unconfirmCurrentItem,
  ]);
  if (isUserDataset.value) {
    dataset.menu.push(exportCurrentDatasetMenu);
  }
  if (currentStudyType.value !== 'motion') {
    dataset.menu.push(exportCurrentDatasetCSVMenu);
  }
});
